module.exports = __webpack_public_path__ + "static/media/coachella-2.fcc17d62.jpg";